"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SheenUtil = void 0;
class SheenUtil {
    static parseSheenFromOptions(options) {
        if (options) {
            if (typeof options.sheen === 'boolean')
                return options.sheen;
        }
        return true;
    }
}
exports.SheenUtil = SheenUtil;
SheenUtil.SHEEN_FILTER_PREFIX = 'brightness(0) saturate(100%)';
